import React, { useEffect, useState } from 'react';
import { ImageBackground, ScrollView, View } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { API } from '../../../service/api';
import styles from './styles';

const LevelStart = ({ navigation }) => {
  const { id_colaborador } = useSelector((state) => state.worker.workerData);
  const { PNFAMisOK } = useSelector((state) => state.worker.pnfamData);
  const [lastPNFAM, setLastPNFAM] = useState('');
  const [status, setStatus] = useState(false);
  const [pnfamExists, setPnfamExists] = useState(false);

  if (PNFAMisOK) setPnfamExists(true);

  useEffect(() => {
    API.post('/search/pnfam', {
      where: `id_colaborador = "${id_colaborador}"`,
      orderby: 'data_preenchimento desc',
      limit: 10,
      offset: 0,
    }).then((result) => {
      setLastPNFAM(result.data?.data[0]?.data_preenchimento);
    });
  }, []);

  useEffect(() => {
    if (lastPNFAM === undefined) {
      return setStatus(true);
    }
    const PNFAM = new Date(lastPNFAM).toDateString();
    for (let i = 0; i < 15; i++) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      if (date.toDateString() === PNFAM) {
        setPnfamExists(true);
        return setStatus(true);
      }
    }
    return setStatus(true);
  }, [lastPNFAM]);

  const dateNewPNFAM = () => {
    const date = new Date(lastPNFAM);
    date.setDate(date.getDate() + 15);
    return date.toLocaleDateString();
  };

  if (!status) {
    return (
      <View />
    );
  }
  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <AppHeader title="PNFAM" hasBack navigation={navigation} />
      <View style={styles.content}>
        <ScrollView style={styles.scroll}>
          <View style={[styles.viewIconHeart, styles.viewBorderedIcon]}>
            <Icon name="fitness-outline" style={styles.iconHeart} />
          </View>
          <AppText style={styles.textPNFAM} size="bold">PREENCHA SUA PNFAM</AppText>
          <AppText style={styles.textPNFAM}>{'Pesquisa de Nível\nFísico, Alimentar e Mental'}</AppText>
          <AppText style={[styles.textPNFAM, styles.textMoreSpace]}>{'A CADA 15 DIAS\nUMA NOVA SOLICITAÇÃO'}</AppText>

          {!!lastPNFAM && (
            <AppText style={styles.textNewPNFAM}>
              {' '}
              Próximo Preenchimento:
              {' '}
              {dateNewPNFAM()}
            </AppText>
          )}

          <AppButton
            style={styles.buttonStart}
            disabled={pnfamExists}
            onPress={
              pnfamExists ? console.log('')
                : () => navigation.navigate('Worker Level One')
            }
          >

            <View style={styles.viewStart}>
              <AppText size="bold" style={styles.textButtonGreen}>
                {pnfamExists ? 'INDISPONÍVEL' : 'COMEÇAR'}
              </AppText>
              <Icon style={styles.iconStart} name="chevron-forward" />
            </View>
          </AppButton>
          <AppText style={styles.textDataSecretPNFAM}>{'Dados confidenciais \napenas a Leths terá acesso.'}</AppText>

        </ScrollView>
      </View>
    </ImageBackground>
  );
};
export default LevelStart;
